module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/compreoalquile_mobile.4625a6da.svg";